import { gql } from 'graphql-request';

export const CREATE_POA_DRAFT = gql`
  mutation CorePOA($inviteId: ID) {
    corePOA {
      createDraft(invitationId: $inviteId)
    }
  }
`;
